// extracted by mini-css-extract-plugin
export default {"block":"running_block__KnX-U","spin":"running_spin__iGm58"};